import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAInvestmentOpportunity, getInvestmentOpportunitys, resetState } from "../features/InvestmentOpportunitySclice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const InvestmentOpportunitylist = () => {
  const [open, setOpen] = useState(false);
  const [InvestmentOpportunityId, setInvestmentOpportunityId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setInvestmentOpportunityId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getInvestmentOpportunitys());
  }, []);
  const getInvestmentOpportunityState = useSelector((state) => state.investmentOpportunity.InvestmentOpportunitys);
  console.log(getInvestmentOpportunityState);
  const data1 = [];
  console.log(getInvestmentOpportunityState.length);
  for (let i = 0; i < getInvestmentOpportunityState.length; i++) {
    data1.push({
      key: i + 1,
      name: getInvestmentOpportunityState[i].opportunityName,

      action: (
        <>
          <Link
            to={`/ppp/Add-Investment-Opportunity/${getInvestmentOpportunityState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getInvestmentOpportunityState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAInvestmentOpportunity(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getInvestmentOpportunitys());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Investment Opportunity List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(InvestmentOpportunityId);
        }}
        title="Are you sure you want to delete this Investment Opportunity?"
      />
    </div>
  );
};

export default InvestmentOpportunitylist;
